<div class="atlas-card-container" [ngStyle]="style">
  <div *ngIf="headerContent" class="atlas-card-header">
    <ng-content select="atlas-header"></ng-content>
  </div>
  <div class="card-body">
    <ng-content></ng-content>
  </div>
  <div *ngIf="footerContent" class="atlas-card-footer">
    <ng-content select="atlas-footer"></ng-content>
  </div>
</div>
